import React, { useState, useEffect } from "react";
import './App.css';
import { BrowserRouter, Router, Routes, Route, Navigate } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';

import StringsLoader from "./assets/strings/StringsLoader";
import HomeEngine from "./components/views/Home/HomeEngine"
import Popup from "./components/shared/Popup";
import PopupMod from "./components/shared/PopupMod";
import InputPopup from "./components/shared/InputPopup";
import SurveyEngine from "./components/views/Survey/SurveyEngine";
import LoadingPopup from "./components/shared/LoadingPopup";

function App() {
  const strLoader = new StringsLoader();

  const [lang, setLang] = useState("");
  const [strings, setStrings] = useState(strLoader.getDefaultStrings());
  const [popupData, setPopupData] = useState({
    visible: false,
    header: "",
    text: "",
    confirmation: false,
  });
  
  const [popupDataMod, setPopupDataMod] = useState({
    visible: false,
    header: "",
    text: "",
    confirmation: false,
  });

  const [inputPopupData, setInputPopupData] = useState({
    visible: false,
    header: "",
    text: "",
    confirmation: false,
  });

  const [loadingData, setLoadingData] = useState({
    visible: false,
    header: "",
    text: "",
    onCancel: null,
  });


  // Carga los strings cuando el lang cambia
  useEffect(() => {
    setStrings(strLoader.getStrings(lang));
  }, [lang]);

  const popupAlert = (header, text, onClose, confirmation, onConfirm, closeText, acceptText, RGPD) => {
    setPopupData({
      visible: true,
      header: header,
      text: text,
      onClose: onClose,
      confirmation: confirmation,
      onConfirm: onConfirm,
      closeText: closeText,
      acceptText: acceptText,
      RGPD: RGPD,
    });
  };

  const popupAlertMod = (header, text1, text2, text3, text4, onClose, confirmation, onConfirm, closeText, acceptText) => {
    setPopupDataMod({
      visible: true,
      header: header,
      text1: text1,
      text2: text2,
      text3: text3,
      text4: text4,
      onClose: onClose,
      confirmation: confirmation,
      onConfirm: onConfirm,
      closeText: closeText,
      acceptText: acceptText,
    });
  };
  
  const popupInputAlert = (header, indexoption, suboptions, actions, config, onClose, confirmation, onConfirm, closeText, acceptText) => {
    setInputPopupData({
      visible: true,
      header: header,
      indexoption: indexoption,
      suboptions: suboptions,
      actions: actions,
      config: config,
      onClose: onClose,
      confirmation: confirmation,
      onConfirm: onConfirm,
      closeText: closeText,
      acceptText: acceptText,
    });
  };

  const popupLoading = (header, text, onCancel) => {
    setLoadingData({
      visible: true,
      header: header,
      text: text,
      onCancel: onCancel
    });
  }

  const getText = (textId) => {
    return strings?.[textId];
  }

  const getTranslatedText = (texts) => {
    if (texts !== null && texts != undefined) {
      if (lang in texts) {
        return texts?.[lang];
      } else if (strLoader.DEFAULT_LANG in texts) {
        return texts?.[strLoader.DEFAULT_LANG];
      } else if (Object.values(texts || {}).length > 0) {
        return Object.values(texts)[0];
      }
    }
  }

  const closePopupAlert = () => {
    setPopupData({ visible: false });
  }

  const closePopupAlertMod = () => {
    setPopupDataMod({ visible: false });
  }
  
  const closeInputPopupAlert = () => {
    setInputPopupData({ visible: false });
  }

  const closePopupLoading = () => {
    setLoadingData({ visible: false });
  }

  const mediaQueries = {
    maxWidth426: useMediaQuery({ query: '(max-width: 426px)' }),
  }

  const childProps = {
    mediaQueries: mediaQueries,
    lang: lang,
    setLang: setLang,
    strings: strings,
    popupAlert: popupAlert,
    closePopupAlert: closePopupAlert,
    popupAlertMod: popupAlertMod,
    closePopupAlertMod: closePopupAlertMod,
    popupInputAlert: popupInputAlert,
    closeInputPopupAlert: closeInputPopupAlert,
    popupLoading: popupLoading,
    closePopupLoading: closePopupLoading,
    getText: getText,
    getTranslatedText: getTranslatedText
  }

  return (
    <>
      <Popup strings={strings} popupData={popupData} setPopupData={setPopupData} />
      <PopupMod strings={strings} popupData={popupDataMod} setPopupData={setPopupDataMod} />
      <InputPopup strings={strings} popupData={inputPopupData} setPopupData={setInputPopupData} />
      <LoadingPopup strings={strings} data={loadingData} />
      <BrowserRouter>
        <Routes>
          <Route path="/survey/:uid/:surveyId" element={<SurveyEngine props={childProps} />} />
          <Route path="*" element={<HomeEngine props={childProps} />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
